import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useMoviesByActor } from '../hooks/useMovie';
import { usePageTitle } from '../hooks/usePageTitle';
import ContentRow from '../components/ui/ContentRow';
import styles from './ActorPage.module.css';
import { FiArrowLeft, FiUser } from 'react-icons/fi';

export default function ActorPage() {
  const { actorId } = useParams();
  const navigate = useNavigate();
  const { data: actor, isLoading, error } = useMoviesByActor(actorId);

  usePageTitle(actor?.Name ? `${actor.Name} · Kast` : 'Actor · Kast');

  if (isLoading) {
    return (
      <div className={styles.page}>
        <div className={`skeleton ${styles.heroSkeleton}`} />
      </div>
    );
  }

  if (error || !actor) {
    return (
      <div className={styles.page}>
        <div className={styles.errorState}>
          <h2>Actor not found</h2>
          <button onClick={() => navigate(-1)}>← Go Back</button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>
      </div>

      <motion.div
        className={styles.profile}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className={styles.photo}>
          {actor.ImageUrl ? (
            <img src={actor.ImageUrl} alt={actor.Name} />
          ) : (
            <FiUser className={styles.photoPlaceholder} />
          )}
        </div>
        <div className={styles.info}>
          <h1 className={styles.name}>{actor.Name}</h1>
          {actor.Bio && <p className={styles.bio}>{actor.Bio}</p>}
          <span className={styles.movieCount}>
            Appears in {actor.Movies.length} title{actor.Movies.length === 1 ? '' : 's'}
          </span>
        </div>
      </motion.div>

      <div className={styles.filmography}>
        {actor.Movies.length > 0 ? (
          <ContentRow title="Filmography" books={actor.Movies} />
        ) : (
          <p className={styles.emptyText}>No titles credited yet.</p>
        )}
      </div>
    </div>
  );
}
